import * as React from "react";
import EditFaultCommon from "../../Editing/EditFaultCommon";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setFaultExtraProperties } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type SignalizationFaultsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingFaults: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.SignalizationSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.SignalizationSubmenu, columnFilter: Filter[]) => void;
};

type SignalizationFaultsTableState = {
  isModalOpen: boolean;
};

export class SignalizationFaultsTable extends React.Component<SignalizationFaultsTableProps, SignalizationFaultsTableState> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingFaults } = this.props;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let signalizationFaultRows: Api.AnyFault[] = [];
    let selectedColumns: State.Column[] = [];

    signalizationFaultRows = pdApi.signalizationFaults ? pdApi.signalizationFaults : [];
    signalizationFaultRows = signalizationFaultRows.map(row => setFaultExtraProperties(row, pdApi));
    selectedColumns = columns["Signalization Faults"];
    const startingPage = mainState.lastEditedObjectId
      ? (signalizationFaultRows.findIndex(fault => fault.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={signalizationFaultRows}
            loading={isLoadingFaults}
            loadingText="Fetching Signalization faults..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isFaultSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view dimmer page"
              style={{ flex: editSize, width: editSize == 0.3 ? "500px" : "1000px" }}
            >
              <EditFaultCommon toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /**
   * Returns status if fault has been selected
   * @param {Api.Fault} fault
   * @returns {boolean}
   */
  private isFaultSelected = (fault: Api.AnyFault): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && fault.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default SignalizationFaultsTable;
